export default ({ request }) => ({
  planOrderListApi(data = {}) {
    return request({
      url: '/factory/plan/order/list',
      method: 'post',
      data
    })
  },
  planOrderDetailApi(data = {}) {
    return request({
      url: '/factory/plan/order/detail',
      method: 'post',
      data
    })
  },
  planOrderDetailListApi(data = {}) {
    return request({
      url: '/factory/plan/order/detail/list',
      method: 'post',
      data
    })
  },
  planOrderScheduleListApi(data = {}) {
    return request({
      url: '/factory/plan/order/schedule/list',
      method: 'post',
      data
    })
  },
  planOrderSpecDetailListApi(data = {}) {
    return request({
      url: '/factory/plan/order/spec/detail/list',
      method: 'post',
      data
    })
  },
  planOrderSpecDetailScheduleListApi(data = {}) {
    return request({
      url: '/factory/plan/order/spec/detail/schedule/list',
      method: 'post',
      data
    })
  },
})
